import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import client from '../../api/client';

export default function BHELAttendance() {
  const user = useSelector(s => s.auth.user) || JSON.parse(localStorage.getItem('user') || '{}');
  const isManagement = user.role === 'BHEL_MANAGEMENT';
  const today = new Date();
  const [month, setMonth] = useState(today.getMonth() + 1);
  const [year, setYear] = useState(today.getFullYear());
  const [locations, setLocations] = useState([]);
  const [locFilter, setLocFilter] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isManagement) client.get('/locations/').then(r => setLocations(r.data?.results || r.data || [])).catch(() => {});
  }, [isManagement]);

  useEffect(() => {
    const params = { month, year };
    if (locFilter) params.location = locFilter;
    setLoading(true);
    client.get('/bhel/attendance/', { params }).then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [month, year, locFilter]);

  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold text-gray-900">RE Attendance</h1>

      {/* Filters */}
      <div className="flex gap-3 flex-wrap">
        <select value={month} onChange={e => setMonth(Number(e.target.value))} className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
          {months.map((m, i) => <option key={i} value={i+1}>{m}</option>)}
        </select>
        <select value={year} onChange={e => setYear(Number(e.target.value))} className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
          {[2024,2025,2026,2027].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        {isManagement && (
          <select value={locFilter} onChange={e => setLocFilter(e.target.value)} className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="">All Locations</option>
            {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
          </select>
        )}
      </div>

      {loading ? <div className="text-center text-gray-400 p-8">Loading…</div> : data.length === 0 ? <div className="text-center text-gray-400 p-8">No records for this period.</div> : (
        <div className="space-y-4">
          {data.map((loc, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
                <h2 className="font-semibold text-gray-800">{loc.location}</h2>
              </div>
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-xs font-semibold text-gray-400 uppercase tracking-wider border-b border-gray-50">
                    <th className="px-6 py-3 text-left">Engineer</th>
                    <th className="px-6 py-3 text-right">Days Present</th>
                    <th className="px-6 py-3 text-right">Days Absent</th>
                    <th className="px-6 py-3 text-right">Total Days</th>
                    <th className="px-6 py-3 text-right">Attendance %</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {loc.engineers.map((eng, j) => (
                    <tr key={j}>
                      <td className="px-6 py-3 font-medium text-gray-800">{eng.name}</td>
                      <td className="px-6 py-3 text-right text-green-600 font-semibold">{eng.present}</td>
                      <td className="px-6 py-3 text-right text-red-500 font-semibold">{eng.absent}</td>
                      <td className="px-6 py-3 text-right text-gray-500">{eng.total}</td>
                      <td className="px-6 py-3 text-right">
                        <span className={`font-bold ${eng.percent >= 90 ? 'text-green-600' : eng.percent >= 75 ? 'text-amber-600' : 'text-red-600'}`}>{eng.percent}%</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
